module.exports = __webpack_public_path__ + "static/img/img_title_tw.7720c83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newYear-2023/img_title_tw.png
// module id = 6GhF
// module chunks = 1